module.exports = __webpack_public_path__ + "img/bus-side.36d85cb8.svg";